<template>
    <div :class="[style.login, theme == 'black' ? style.loginBlack : style.loginWhite]" @keydown="errors.clear($event.target.name)">
        <div :class="[style.loginContent]">
            <input-label :id="`f${(~~(Math.random()*1e8)).toString(16)}`"
                            v-model="formData.login.value"
                            :name="'login'"
                            :error="errors.get('login')"
                            :theme="theme"
                            :placeholder="'Логин'" />

            <input-label :id="`f${(~~(Math.random()*1e8)).toString(16)}`"
                            v-model="formData.password.value"
                            style="padding-top: 2px;"
                            :isPassword="true"
                            :name="'password'"
                            :theme="theme"
                            :error="errors.get('password')"
                            :placeholder="'Пароль'"
                            @input="resetErrors" />
            <a style="text-decoration: underline; font-size: 13px;" :href="`${SSOSiteUrl}/RecoverPasswordRequest.aspx`" :target="target">Восстановить пароль</a>
        </div>
        <div v-show="!isLoading" :class="[style.loginActions, modalStyle.modalActions]">
            <buttonRed :size="'sm'" @click="validateAndLogin">Войти</buttonRed>
        </div>

        <pulse-loader :class="[style.pulseLoader]" :loading="isLoading" color="#cc181e" />
    </div>
</template>

<script>
    import { dataLoader } from '../data-loader-mixin'
    import { yandexMetrika } from '../yandex-metrika-mixin';
    import style from './style.module.scss';
    import modalStyle from '../modal/style.module.scss'

    import inputLabel from '../inputs/text-input/input-label';
    import buttonRed from '../buttons/button-red';
    import pulseLoader from 'vue-spinner/src/PulseLoader.vue'

    import { Errors, Validator } from '../form.js'

    export default {
        name: 'Login',
        components: {
            buttonRed,
            inputLabel,
            pulseLoader
        },
        mixins: [dataLoader, yandexMetrika],
        props: {
            theme: {
                type: String,
                default: ''
            },
            text: {
                type: String,
                default: ''
            },
            target: {
                type: String,
                default: '_self'
            },
            actionParams: {
                type: Object,
                default() {
                    return null;
                }
            },
            widgetData: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            autoInit: {
                type: Object,
                default: () => {
                    return {
                        login: null,
                        message: null,
                    }
                }
            },
            note: {
                type: String,
                required: false,
                default: 'Авторизуйтесь, чтобы посмотреть ранее созданные запросы.'
            }
        },
        data() {
            return {
                style: style,
                modalStyle: modalStyle,
                formData: {
                    login: {
                        name: 'login',
                        value: '',
                        validationData: [
                            { type: 'required', message: 'Поле должно быть заполнено' }
                        ]
                    },
                    password: {
                        name: 'password',
                        value: '',
                        validationData: [
                            { type: 'required', message: 'Поле должно быть заполнено' }
                        ]
                    },
                },
                validator: new Validator(),
                errors: new Errors(),
                agreementErrorText: '',
                isLoading: false,
                SSOSiteUrl: process.env.VUE_APP_SSO_SITE_URL,
            }
        },
        mounted() {
            if (this.autoInit && this.autoInit.login && this.autoInit.message) {
                this.formData.login.value = this.autoInit.login;
                this.errors.record({ name: this.formData.login.name, message: this.autoInit.message });
                this.$forceUpdate();
            }
        },
        methods: {
            resetErrors() {
                this.errors.clearAll();
            },
            validateAndLogin() {
                this.errors.clearAll();
                this.validator.validate(this.formData, this.errors, this);

                if (!this.errors.any()) {
                    this.$forceUpdate();
                    this.loginViaCredentials();
                }
            },
            changeSignState() {
                this.$emit('changeState', 'reg')
            },
            loginViaCredentials() {
                this.isLoading = true;
                const pickProfitRoute = !!(this.autoInit && this.autoInit.login);
                const urlReferrer = window && encodeURIComponent(window.location.href);
                this.login(
                    {
                        userName: this.formData.login.value, 
                        password: this.formData.password.value, 
                        widgetInfo: this.widgetData, 
                        pickProfitRoute: pickProfitRoute,
                        urlReferrer: urlReferrer 
                    }, 
                    (data) => this.proccessLogin(data)
                );
            },
            async proccessLogin(data) {
                if (data.isSuccess === true && data.redirectUrl) {
                    this.isLoading = false;            
                    this.$emit('logged');
                    this.sendToYandexMetrikaAuthorizationFromSupplierFinder();
                    await this.$store.dispatch('getUserInfo')
                    this.$store.dispatch('getProjectsInfo')
                } else {
                    this.isLoading = false;
                    
                    this.errors.record(
                        { 
                            name: this.formData.login.name, 
                            message: data.errorMessage != undefined ? data.errorMessage : 'Произошла ошибка при авторизации' 
                        }
                    );
                    
                    this.$forceUpdate();
                }
            }
        }
    }
</script>